import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable */
import React, { useState } from "react";
import { t } from "i18next";
import { useStoreState } from "pullstate";
import { get, set } from "lodash";
import { add } from "date-fns";
import Store from "../../utils/Store";
import Button from "../common/Button";
import Filters from "./Filters";
import { patientsExportService, downloadFile } from "../ExportMessage/services/downloadService";
import { formatFiltersObj } from "../SearchFilters/utils";
import { isValidDate } from "../../utils";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
var initialFilters = {
  dateRange: [null, null],
  site: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  }
};
var ExportData = function ExportData(props) {
  var onClose = props.onClose;
  var _useState = useState(initialFilters),
    filters = _useState[0],
    setFilters = _useState[1];
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        downloadProgress: store.downloadProgress,
        isStartingDownload: store.isStartingDownload,
        isExportReady: store.isExportReady,
        exportTimestamp: store.exportTimestamp,
        exportGenFailed: store.exportGenFailed,
        isDarkMode: store.isDarkMode
      };
    }),
    downloadProgress = _useStoreState.downloadProgress,
    isStartingDownload = _useStoreState.isStartingDownload,
    isExportReady = _useStoreState.isExportReady,
    exportTimestamp = _useStoreState.exportTimestamp,
    exportGenFailed = _useStoreState.exportGenFailed,
    isDarkMode = _useStoreState.isDarkMode;

  // Check if CSV generation is in progress
  var isGenerationInProgress = isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady;
  var getFormattedFilters = function getFormattedFilters(filters) {
    var formattedFilters = formatFiltersObj(filters);
    var startDate = get(formattedFilters, ["start_study_date"], "");
    var endDate = get(formattedFilters, ["end_study_date"], "");
    if (startDate) {
      var startDateVal = new Date(startDate);
      var endDateVal = add(new Date(endDate), {
        days: 1
      });
      if (isValidDate(startDateVal) && isValidDate(endDateVal)) {
        startDateVal.setHours(0, 0, 0);
        endDateVal.setHours(0, 0, 0);
        set(formattedFilters, ["start_study_date"], startDateVal.toISOString());
        set(formattedFilters, ["end_study_date"], endDateVal.toISOString());
      }
    }
    return _objectSpread(_objectSpread({}, formattedFilters), {}, {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  };
  var startDownload = function startDownload() {
    if ((downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload) {
      Store.update(function (s) {
        s.isExportReady = false;
        s.downloadProgress = 1;
        s.exportGenFailed = false;
        s.isStartingDownload = true;
      });
      var url = "patients_export/start_generation/";
      var formattedFilters = getFormattedFilters(filters);
      trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_SUBMIT, formattedFilters);
      patientsExportService(url, formattedFilters).then(function (response) {
        Store.update(function (s) {
          s.isStartingDownload = false;
        });
        if (response !== null && response !== void 0 && response.success) {
          Store.update(function (s) {
            s.isExportReady = false;
            s.downloadProgress = 1;
            s.exportGenFailed = false;
          });
        }
      })["catch"](function (resp) {
        Store.update(function (s) {
          s.isExportReady = false;
          s.downloadProgress = 0;
          s.exportGenFailed = true;
          s.isStartingDownload = false;
        });
      });
    }
    onClose();
  };
  var onCloseModal = function onCloseModal() {
    trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_CANCEL, {
      type: "cancel_button"
    });
    onClose();
  };
  var handleDownload = function handleDownload() {
    downloadFile();
    trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_SETTINGS);
  };
  var cancelExport = function cancelExport() {
    Store.update(function (s) {
      s.isExportReady = false;
      s.downloadProgress = 0;
      s.isStartingDownload = false;
      s.exportGenFailed = false;
      s.showExportUpdate = false;
    });
    trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_CANCEL, {
      type: "cancel_export"
    });
  };
  var startNewExport = function startNewExport() {
    Store.update(function (s) {
      s.isExportReady = false;
      s.downloadProgress = 0;
      s.isStartingDownload = false;
      s.exportGenFailed = false;
      s.showExportUpdate = false;
    });
    trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_CANCEL, {
      type: "start_new_export"
    });
  };

  // Show CSV generation in progress state
  if (isGenerationInProgress) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "m-4 flex flex-col items-center justify-center space-y-6 h-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center space-y-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-16 h-16"
    }, /*#__PURE__*/React.createElement(CircularProgressbar, {
      value: downloadProgress,
      styles: buildStyles({
        rotation: 0.25,
        strokeLinecap: "butt",
        textSize: "24px",
        pathTransitionDuration: 0.5,
        pathColor: "rgba(0, 130, 128)",
        textColor: "#f88",
        trailColor: isDarkMode ? "white" : "#b6aeae",
        backgroundColor: "white"
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-lg font-semibold text-center"
    }, t("export_data.downloaded")), /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-gray-600 dark:text-gray-400 text-center"
    }, t("please_wait")))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center flex-row justify-end gap-4 p-4 border-t border-t-gray-600"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "grow-1 w-full sm:w-40",
      onClick: onCloseModal
    }, t("button.cancel")), /*#__PURE__*/React.createElement(Button, {
      className: "grow-1 w-full sm:w-40 bg-red-600 hover:bg-red-700 text-white",
      onClick: cancelExport,
      dataTestId: "cancel-export-button"
    }, t("Cancel Export"))));
  }

  // Show CSV ready state with download button
  if (isExportReady) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "m-4 flex flex-col items-center justify-center space-y-6 h-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center space-y-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-16 h-16 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "64",
      height: "64",
      viewBox: "0 0 20 18",
      fill: "#00D0CD",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M17.0391 10.6875H15.0537L13.2725 12.375H17.0391C17.3664 12.375 17.6328 12.6274 17.6328 12.9375V15.75C17.6328 16.0601 17.3664 16.3125 17.0391 16.3125H2.78906C2.46168 16.3125 2.19531 16.0601 2.19531 15.75V12.9375C2.19531 12.6281 2.46176 12.375 2.78906 12.375H6.55566L4.77441 10.6875H2.78906C1.47725 10.6875 0.414062 11.6947 0.414062 12.9375V15.75C0.414062 16.9928 1.47725 18 2.78906 18H17.0391C18.3509 18 19.4141 16.9928 19.4141 15.75V12.9375C19.4141 11.6965 18.349 10.6875 17.0391 10.6875ZM16.4453 14.3438C16.4453 13.8776 16.0464 13.5 15.5547 13.5C15.063 13.5 14.6641 13.8762 14.6641 14.3438C14.6641 14.8096 15.063 15.1875 15.5547 15.1875C16.0464 15.1875 16.4453 14.8113 16.4453 14.3438ZM9.2832 12.941C9.45762 13.1379 9.68398 13.2188 9.91406 13.2188C10.1441 13.2188 10.3698 13.1363 10.5438 12.9716L15.5907 8.19032C15.9386 7.86073 15.9386 7.32688 15.5907 6.99711C15.2428 6.66735 14.6793 6.66752 14.3312 6.99711L10.8047 10.3395V0.84375C10.8047 0.37793 10.4076 0 9.91406 0C9.42051 0 9.02344 0.37793 9.02344 0.84375V10.3395L5.46465 6.99609C5.11675 6.6665 4.55324 6.6665 4.20516 6.99609C3.85707 7.32568 3.85726 7.85953 4.20516 8.1893L9.2832 12.941Z"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "text-lg font-semibold text-center"
    }, t("export_data_modal.download_export_data")), exportTimestamp && /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-gray-600 dark:text-gray-400 text-center"
    }, t("export_data_modal.generated_on", {
      timestamp: exportTimestamp
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center flex-row justify-end p-4 border-t border-t-gray-600"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "grow-1 w-full sm:w-40",
      onClick: startNewExport,
      dataTestId: "start-new-export-button"
    }, "Start New Export"), /*#__PURE__*/React.createElement(Button, {
      isPrimary: true,
      onClick: handleDownload,
      className: "sm:mt-0 grow-1 ml-4 w-full sm:w-40",
      dataTestId: "download-csv-button"
    }, t("export_data_modal.download_export_data"))));
  }

  // Show normal form state (not started or failed)
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "m-4 flex flex-col text-left space-y-4 h-full"
  }, exportGenFailed && /*#__PURE__*/React.createElement("div", {
    className: "p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-red-600 dark:text-red-400"
  }, "Failed")), /*#__PURE__*/React.createElement(Filters, {
    filters: filters,
    setFilters: setFilters
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-row justify-end p-4 border-t border-t-gray-600"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "grow-1 w-full sm:w-40",
    onClick: onCloseModal
  }, t("button.cancel")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    onClick: startDownload,
    className: "sm:mt-0 grow-1 ml-4 w-full sm:w-40",
    dataTestId: "export-data-button"
  }, t("export_data"))));
};
export default ExportData;